import { requireFields } from 'bundles/naptimejs/util/requireFieldsDecorator';
import PaymentProcessorTypes from 'bundles/payments-common/common/PaymentProcessorTypes';

import NaptimeResource from './NaptimeResource';

class ValidPaymentProcessors extends NaptimeResource {
  static RESOURCE_NAME = 'validPaymentProcessors.v1';

  // These properties are always included.
  declare id: string;

  declare processors: Array<keyof typeof PaymentProcessorTypes>;

  @requireFields('processors')
  get isBraintreeEnabled(): boolean {
    return (
      this.processors.includes(PaymentProcessorTypes.braintree) ||
      this.processors.includes(PaymentProcessorTypes.braintreeSandbox)
    );
  }

  @requireFields('processors')
  get isRazorpayEnabled(): boolean {
    return (
      this.processors.includes(PaymentProcessorTypes.razorpay) ||
      this.processors.includes(PaymentProcessorTypes.razorpaySandbox)
    );
  }

  /**
   * Returns if stripeConsumer or stripeBvConsumer is enabled, include sandbox
   * @return {boolean} True if stripeConsumer or stripeBvConsumer is enabled
   */
  @requireFields('processors')
  get isStripeEnabled(): boolean {
    return (
      this.processors.includes(PaymentProcessorTypes.stripeConsumer) ||
      this.processors.includes(PaymentProcessorTypes.stripeConsumerSandbox) ||
      this.processors.includes(PaymentProcessorTypes.stripeBvConsumer) ||
      this.processors.includes(PaymentProcessorTypes.stripeBvConsumerSandbox)
    );
  }

  /**
   * Returns if stripeBvConsumer is enabled, include sandbox
   * @return {boolean} True if stripeBvConsumer is enabled
   */
  @requireFields('processors')
  get isStripeBvEnabled(): boolean {
    return (
      this.processors.includes(PaymentProcessorTypes.stripeBvConsumer) ||
      this.processors.includes(PaymentProcessorTypes.stripeBvConsumerSandbox)
    );
  }

  @requireFields('processors')
  get isPaypalEnabled(): boolean {
    return this.processors.includes(PaymentProcessorTypes.paypal);
  }

  @requireFields('processors')
  get isZeroDollar(): boolean {
    return this.processors.includes(PaymentProcessorTypes.zeroDollar);
  }
}

export default ValidPaymentProcessors;
